module.exports = __webpack_public_path__ + "static/media/MovingApp_android_5_preview.6e9f3812.jpg";